class ShowMoreContent extends HTMLElement {
  constructor() {
    super();

    this.maxHeightLine = parseInt(this.dataset.maxLines, 10) || 6;
    this.showMoreBtn = this.querySelector('.more-button');
    this.showLessBtn = this.querySelector('.less-button');
    this.descriptionContent = this.querySelector('.content');

    if (!this.showMoreBtn || !this.showLessBtn || !this.descriptionContent) {
      return;
    }

    this.init();
  }

  getContentHeight() {
    this.descriptionContent.style.display = 'block';
    this.descriptionContent.style.webkitLineClamp = 'unset';
    this.descriptionContent.style.webkitBoxOrient = 'unset';
    this.descriptionContent.style.overflow = 'visible';

    const maxHeight = this.descriptionContent.offsetHeight;

    this.descriptionContent.style.display = '-webkit-box';
    this.descriptionContent.style.webkitLineClamp = this.maxHeightLine;
    this.descriptionContent.style.webkitBoxOrient = 'vertical';
    this.descriptionContent.style.overflow = 'hidden';

    return maxHeight;
  }

  init() {
    const maxHeight = this.maxHeightLine * parseFloat(getComputedStyle(this.descriptionContent).lineHeight) + 10;
    const contentHeight = this.getContentHeight();

    if (contentHeight <= maxHeight) {
      return;
    }

    this.descriptionContent.setAttribute('aria-expanded', 'false');
    this.descriptionContent.id = `description-${Date.now()}`;
    this.showMoreBtn.setAttribute('aria-controls', this.descriptionContent.id);
    this.showLessBtn.setAttribute('aria-controls', this.descriptionContent.id);

    this.displayMoreButton();

    this.showMoreBtn.addEventListener('click', () => {
      this.displayLessButton();
    });

    this.showLessBtn.addEventListener('click', () => {
      this.displayMoreButton();
    });
  }

  displayMoreButton() {
    this.showMoreBtn.removeAttribute('hidden');
    this.showLessBtn.setAttribute('hidden', true);

    this.descriptionContent.style.display = '-webkit-box';
    this.descriptionContent.style.webkitLineClamp = this.maxHeightLine;
    this.descriptionContent.style.webkitBoxOrient = 'vertical';
    this.descriptionContent.style.overflow = 'hidden';

    this.descriptionContent.setAttribute('aria-expanded', 'false');

    // LV 23.09.2026: fokus tylko po kliknieciu "Pokaz mniej" - przy wczytaniu strony
    // przycisk dostawal fokus sam z siebie i wisiala na nim niebieska ramka
    if (document.activeElement === this.showLessBtn) this.showMoreBtn.focus();
  }

  displayLessButton() {
    this.showMoreBtn.setAttribute('hidden', true);
    this.showLessBtn.removeAttribute('hidden');

    this.descriptionContent.style.display = 'block';
    this.descriptionContent.style.webkitLineClamp = 'unset';
    this.descriptionContent.style.webkitBoxOrient = 'unset';
    this.descriptionContent.style.overflow = 'visible';

    this.descriptionContent.setAttribute('aria-expanded', 'true');

    this.showLessBtn.focus();
  }
}

customElements.define('show-more-content', ShowMoreContent);